import React from 'react';
import { ProductCard } from './ProductCard';
import type { Product } from '../../types/commerce';
export function ProductGrid({
  products,
  loading = false
}: {
  products: Product[];
  loading?: boolean;
}) {
  if (loading) {
    return <div className="grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-266" data-mp="1tfei90eskgj6">
        {[0, 1, 2].map(key => <div key={key} className="animate-pulse" data-id="element-267" data-mp="1odyxzakfue1u">
            <div className="aspect-[4/5] w-full rounded-3xl bg-white/5" data-id="element-268" data-mp="2l5awrr4uiyip" />
            <div className="mt-6 h-5 w-2/3 rounded-full bg-white/5" data-id="element-269" data-mp="2h50gnlncarq4" />
            <div className="mt-3 h-4 w-full rounded-full bg-white/5" data-id="element-270" data-mp="2h2mk18d0h7gg" />
          </div>)}
      </div>;
  }
  if (products.length === 0) {
    return <p className="text-base text-white/50" data-id="element-271" data-mp="275i0zhegps3v">
        Nothing in the shop right now. Join the list and we will tell you the
        moment it opens.
      </p>;
  }
  return <div className="grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-272" data-mp="vquvpdcqcdtr">
      {products.map(product => <ProductCard key={product.handle} product={product} data-id="element-273" data-mp="13g10qg0817so" />)}
    </div>;
}